/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ project: NonNullable<unknown>, date: NonNullable<unknown> }} Chat_Shared_Existing_Copy_LinkInputs */



/**
* | output |
* | --- |
* | "in {project} · {date}" |
*
* @param {Chat_Shared_Existing_Copy_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_shared_existing_copy_link = /** @type {((inputs: Chat_Shared_Existing_Copy_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Shared_Existing_Copy_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`in ${i?.project} · ${i?.date}`)
	return /** @type {LocalizedString} */ (`in ${i?.project} · ${i?.date}`)
});